import { render, staticRenderFns } from "./chooseProduct.vue?vue&type=template&id=5da15f4a&scoped=true"
import script from "./chooseProduct.vue?vue&type=script&lang=js"
export * from "./chooseProduct.vue?vue&type=script&lang=js"
import style0 from "./chooseProduct.vue?vue&type=style&index=0&id=5da15f4a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5da15f4a",
  null
  
)

export default component.exports